import { Injectable } from '@angular/core';
import { CommodityFilters } from '../models/filters/commodity-filters';
import { Commodity } from '../models/commodity/commodity';
import { environment } from '../../../../environments/environment';
import { combineLatest, Observable } from 'rxjs';
import { DataQueryService } from './data-query/data-query.service';
import { DataQueryServiceConfiguration } from './data-query/data-query-service-configuration';


@Injectable({
  providedIn: 'root'
})
export class CommodityDataService extends DataQueryService {
  override prefetch(): Observable<any> {
    return combineLatest([this.prefetchGet(CommodityDataServiceConfiguration.AllCommodities)]);
  }

  getCommodities(filters?: CommodityFilters) {
    return this.get<Commodity[]>(CommodityDataServiceConfiguration.AllCommodities);
  }

  getCarTypes() {
    return this.get<string[]>(CommodityDataServiceConfiguration.AllCarTypes);
  }
}

abstract class CommodityDataServiceConfiguration {
      static readonly AllCommodities = new DataQueryServiceConfiguration<Commodity[]>(
        'commodities',
         environment.apiUrl + 'Commodities'
    );

    static readonly AllCarTypes = new DataQueryServiceConfiguration<string[]>(
        'carTypes',
        environment.apiUrl + 'CarTypes'
    );
  }
